export const CPF_LENGTH = 11
